import { React, useState, useEffect } from 'react';
import classNames from 'classnames';

const SubLevel = ({ item, current, classname, CloseNav }) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const [isExpanded, setIsExpanded] = useState(false);

  const node = window.document.querySelector(
    `[data-section=${item.SectionLink}]`
  );

  const hasCurrent = node && Boolean(node.querySelector('.current'));
  const isCurrent = current === item.SectionLink;
  const isActive = hasCurrent || isCurrent;

  const active = isCurrent ? 'current' : '';

  const classes = classNames({
    [`anchor-nav-multi__navigation__${classname}`]: true,
    'anchor-nav-multi__navigation--is-expanded':
      (isExpanded && item?.Children?.length > 0) || isActive,
  });

  const buttonAttributes = {
    onClick: () => setIsExpanded(!isExpanded),
    'aria-controls': item.SectionLink,
    'aria-expanded': isExpanded,
    className: isExpanded
      ? 'anchor-nav-multi__navigation__expand-btn anchor-nav-multi__navigation__expand-btn--is-expanded'
      : 'anchor-nav-multi__navigation__expand-btn anchor-nav-multi__navigation__expand-btn--is-closed',
    id: `btn-${item.SectionLink}`,
  };

  const baseClassName =
    'anchor-nav-multi__navigation__second-level__section__items';
  const sectionClassName = classNames({
    [baseClassName]: true,
    [`${baseClassName}--shown`]: hasCurrent,
    [`${baseClassName}--opened`]: isExpanded,
  });

  useEffect(() => {
    const section = window.document.querySelector(
      `[data-section=${item.SectionLink}]`
    );
    isActive || (isExpanded && setIsExpanded(true));
    !isActive && !isExpanded && setIsExpanded(false);

    section.hasAttribute('style') && section.removeAttribute('style');
  }, [current]);

  return (
    <li
      className={classes}
      aria-hidden={!isExpanded && !isActive}
      data-section={item.SectionLink}
    >
      <a
        onClick={() => {
          CloseNav && CloseNav();
        }}
        className={active}
        data-cy="anchor-nav-list-link"
        href={`#${item.SectionLink}`}
      >
        {item.Name}
      </a>

      {item.Children && (
        <>
          <button {...buttonAttributes} />
          <ul className={sectionClassName}>
            {item.Children.map((item, key) => (
              <SubLevel
                key={key}
                item={item}
                current={current}
                classname="third-level"
                CloseNav={CloseNav}
              />
            ))}
          </ul>
        </>
      )}
    </li>
  );
};

export default SubLevel;
